let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("alKbB")).then(() => parcelRequire('9rDEK'));